// extracted by mini-css-extract-plugin
export default {"stickableMenu":"SubsidiesPage_stickableMenu__Zl9bi","placeHolderShimmer":"SubsidiesPage_placeHolderShimmer__-cdiC"};